module.exports = __webpack_public_path__ + "img/49.18df1312.jpg";